import {callTargetedAction} from 'client/framework';
import questionTypeActions from 'components/QuestionTypes/questionType.actions';
import {getStoreByName} from 'client/components/QuestionTypes/V2/useQuestionStores';

export default function clearGuess(questionStoreName: string) {
  const zustandStore = getStoreByName(questionStoreName);
  if (zustandStore) {
    const storeState = zustandStore.getState();
    if (typeof storeState.clearGuess === 'function') {
      storeState.clearGuess();
      return;
    }
  }

  callTargetedAction({
    name: questionTypeActions.CLEAR_GUESS,
    targetStore: questionStoreName
  });
}
